import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';
import { TextsForAppComponent } from '../pages/cms/texts-for-app/texts-for-app.component';

@Injectable({
  providedIn: 'root',
})
export class AppTextsFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<TextsForAppComponent>
{
  canDeactivate(
    component: TextsForAppComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(component.hasChanges, nextState.url);
  }
}
